import React, { useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';

type JoinWaitlistModalProps = {
  onSubmit: (comment: string) => void;
  onHide: VoidFunction;
  show: boolean;
  submitting?: boolean;
};

const JoinWaitlistModal: React.FC<JoinWaitlistModalProps> = ({ show, onHide, onSubmit, submitting }) => {
  const [comment, setComment] = useState('');

  if (!show) {
    return null;
  }

  return (
    <Modal show={true} onHide={onHide}>
      <Modal.Header className="font-size-16 font-weight-bold" closeButton>
        Join Waitist
      </Modal.Header>
      <Modal.Body>
        <div>
          <p className="mt-1">
            Although we don't have a community for your business just yet, we'd like to get it set up as soon as we can.
          </p>
          <p>
            If you can give us some ideas of what would be a suitable community for you, that will help us expedite the
            process.
          </p>
          <span>Comment</span>
          <Form>
            <Form.Group controlId="comment">
              <Form.Control
                className="small"
                as="textarea"
                placeholder="Eg. Your downtown, your city, your county, etc."
                value={comment}
                rows={3}
                maxLength={128}
                // tslint:disable-next-line:no-any
                onChange={(e: any) => {
                  setComment(e.target.value);
                }}
              />
            </Form.Group>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer className="mx-3 mt-3 px-0">
        <Button disabled={submitting} variant="outline-secondary" className="mx-2 px-4" onClick={onHide}>
          Cancel
        </Button>
        <Button className="px-4" disabled={submitting} onClick={() => onSubmit(comment)}>
          {submitting ? <Spinner animation="border" size="sm" variant="light" /> : 'Submit'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default JoinWaitlistModal;
